import React from "react";
import { Typography } from "@mui/material";

const Location = ({ name, address }) => {
    return <Typography variant="body2">{name}</Typography>;
};

export default Location;
